import DatePicker from "react-datepicker";
import React, { useState, useEffect, useImperativeHandle } from "react";
import queryString from "query-string";
import moment from "moment";
import history from "shared_history";
import { Button } from 'react-bootstrap';
import {flashMessages} from "ducks";
import {connect} from 'react-redux';
import PropTypes from "prop-types";

const MonthYearDateFilterImpl = ({
  location, dispatch, maxMonthRange, defaultMonthRange, hideStartDate, defaultStartDate, onDatesChange
}, ref) => {
  const query = queryString.parse(location.search);
  const [startDate, setStartDate] = useState((!hideStartDate && query.start_date) ? moment(query.start_date).toDate() : defaultStartDate);
  const [endDate, setEndDate] = useState(query.end_date ? moment(query.end_date).toDate() : moment(startDate).add(defaultMonthRange, 'months').endOf('month').toDate());

  const updateUrlWithDates = (nextStart, nextEnd) => {
    const monthsDiff = moment(nextEnd).endOf('month').diff(moment(nextStart), 'months', true);
    if (maxMonthRange < 0 || monthsDiff <= maxMonthRange) {
      // IMPORTANT: always read the latest URL params when updating
      const searchParams = { ...queryString.parse(location.search) };
      if (!hideStartDate) {
        searchParams.start_date = moment(nextStart).format('YYYY-MM-DD');
      }
      searchParams.end_date = moment(nextEnd).endOf('month').format('YYYY-MM-DD');

      history.push({
        ...location,
        search: `?${queryString.stringify(searchParams)}`
      });
    } else {
      dispatch(flashMessages.actions.show( {message: `Dates cannot exceed ${maxMonthRange} month period.`, type: 'danger', dismissible: true}))
    }
  };
  const updateUrl = () => updateUrlWithDates(startDate, endDate);

  useEffect(() => {
    updateUrl()
  }, [])

  // Sync local picker state when URL (location.search) changes externally
  useEffect(() => {
    const q = queryString.parse(location.search);
    if (!hideStartDate && q.start_date) {
      setStartDate(moment(q.start_date).toDate());
    }
    if (q.end_date) {
      setEndDate(moment(q.end_date).toDate());
    }
  }, [location.search]);

  useImperativeHandle(ref, () => ({
    submitDates: updateUrl,
    getCurrentDates: () => ({
      start_date: hideStartDate ? undefined : moment(startDate).format('YYYY-MM-DD'),
      end_date: moment(endDate).endOf('month').format('YYYY-MM-DD')
    })
  }));

  return (
    <div>
      { !hideStartDate && (
        <label className='date-filter-label'>
          Start Month
          <DatePicker
            dateFormat='MMM yyy'
            showMonthYearPicker
            className='input-small date-filter-input'
            selected={startDate}
            onChange={(date) => { setStartDate(date); onDatesChange && onDatesChange({ start_date: moment(date).format('YYYY-MM-DD'), end_date: moment(endDate).endOf('month').format('YYYY-MM-DD') }); }}
            name='start_date'
            placeholder='Start Date'
          />
        </label>
      )}

      <label className='date-filter-label'>
        End Month
        <DatePicker
          dateFormat='MMM yyy'
          showMonthYearPicker
          className='input-small date-filter-input'
          selected={endDate}
          minDate={startDate}
          onChange={(date) => { setEndDate(date); onDatesChange && onDatesChange({ start_date: hideStartDate ? undefined : moment(startDate).format('YYYY-MM-DD'), end_date: moment(date).endOf('month').format('YYYY-MM-DD') }); }}
          name='end_date'
          placeholder='Start Date'
        />
      </label>

      <Button onClick={updateUrl}>Submit</Button>
    </div>
  );
};

const MonthYearDateFilter = React.forwardRef(MonthYearDateFilterImpl);

MonthYearDateFilter.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    search: PropTypes.string
  }).isRequired,
  // Default none
  maxMonthRange: PropTypes.number,
  defaultMonthRange: PropTypes.number,
  hideStartDate: PropTypes.bool,
  defaultStartDate: PropTypes.object
};
MonthYearDateFilter.defaultProps = {
  maxMonthRange: -1,
  defaultMonthRange: 0,
  hideStartDate: false,
  defaultStartDate: moment().startOf('month').toDate()
};

export default (connect(undefined, undefined, undefined, { forwardRef: true })(MonthYearDateFilter));
